"use client"

import React from 'react';
import {useAppStore} from "@/store/AppStore";
import {TreeItem} from "@mui/x-tree-view/TreeItem";
import {CircularProgress} from "@mui/material";
import {Liturgy} from "@/types/Liturgies";
import useBlessingsData from "@/utils/hooks/useBlessingsData";

// La selezione e' gestita dal `SimpleTreeView` parent via
// `onItemSelectionToggle` (vedi Pray.tsx). Qui montiamo solo i nodi.
export default function BlessingsItems() {

  const user = useAppStore((state) => state.user);
  const data = useBlessingsData(user?.access_token)

  const items = data?.items

  if (!user) return null
  if (!data) return <CircularProgress/>

  return (
    <>
      {items && items.map((itm: Liturgy, key: number) => {
        return <TreeItem key={key} label={itm.name} itemId={`blessing-${itm.id}`}/>
      })
      }
    </>
  )
}
